import { useMutation, useQueryClient } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { toast } from "@/components/toast/CustomToast";
import { useScheduleStore } from "@/store/scheduleStore";

export default function useDeleteRosterMutation() {
  const queryClient = useQueryClient();
  const { curDate, curScheduleInfo, setCurScheduleInfo } = useScheduleStore();

  return useMutation({
    mutationFn: async (schedule_id: string) => {
      await httpClient.delete(`/roster/${schedule_id}`);
      return schedule_id;
    },
    onSuccess: async (deletedScheduleId) => {
      // 1. 삭제된 scheduleId를 추적 Set에 추가 (useRosterSchedule에서 요청 방지)
      const { addDeletedScheduleId } = useScheduleStore.getState();
      addDeletedScheduleId(deletedScheduleId);

      // 2. 삭제된 버전이 현재 선택된 버전인 경우
      if (curScheduleInfo?.scheduleId === deletedScheduleId) {
        // 진행 중인 쿼리를 취소하여 404 요청 방지
        await queryClient.cancelQueries({
          queryKey: ["ROSTER_SCHEDULE", deletedScheduleId],
        });

        // curScheduleInfo를 null로 설정하여 useRosterSchedule이 요청하지 않도록
        setCurScheduleInfo(null);
      }

      // 3. 삭제된 scheduleId의 스케줄 데이터 캐시 제거
      await queryClient.removeQueries({
        queryKey: ["ROSTER_SCHEDULE", deletedScheduleId],
      });

      // 4. 버전 리스트 무효화
      await queryClient.invalidateQueries({
        queryKey: ["VERSIONS", curDate?.year, curDate?.month],
      });

      toast.success("근무표가 삭제되었습니다.");
    },
  });
}
